module.exports = __webpack_public_path__ + "img/Specom-α.ec6ae1e2.png";